// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/iconfont.css';
import axios from 'axios';
import store from '@/store/index';
import https from '@/https.js';
import util from '@/util.js';
import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill();
Vue.prototype.$axios = axios;
import QS from 'qs'
Vue.prototype.qs = QS;
Vue.use(ElementUI);
Vue.use(https);
Vue.use(store);
Vue.config.productionTip = false
Vue.prototype.https = https;
router.beforeEach((to, from, next) => { // 使用钩子函数对路由进行权限跳转
	util.IEVersion();//判断当前浏览器能否使用
	window.document.title = to.meta.title == undefined?'':to.meta.title
	if (to.matched.length === 0) { //如果未匹配到路由
		from.name ? next(from.name) : next('login'); //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
	} else {
		next(); //如果匹配到正确跳转
	}
	var time = Math.floor(Date.now() / 1000);
	var clientExpiresIn = parseInt(localStorage.getItem('CLIENT_EXPIRES'));
	store.dispatch('checkLoginFun', 0) //顶部导航判断是否要显示
	if (clientExpiresIn < time && to.path !== '/login'&& to.path !== '/') { // 如果用户不存在，并且访问的页面不是登录和注册，就前往登录页面
		next('login');
	} else {
		if (to.path !== '/login' && clientExpiresIn > time&& to.path !== '/') {
			store.dispatch('checkLoginFun', 1);
		}
		next()
	}
})
new Vue({
	el: '#app',
	store,
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js